import { Link } from 'react-router-dom';
import { ArrowRight, Check, ChevronRight, Circle } from 'lucide-react';
import StatusBadge from 'components/StatusBadge';
import { CARD_BTN, MAX_ROWS } from './helper';

const Row = ({ label, done, optional = false, pendingClass = 'text-secondary-300' }) => (
  <li className="flex items-start gap-2.5 text-sm text-secondary-700">
    {done && <Check size={16} strokeWidth={2.5} className="mt-0.5 shrink-0 text-green-600" />}
    {!done && optional && <span className="mt-0.5 h-4 w-4 shrink-0 rounded-full border-[1.5px] border-dashed border-secondary-300" />}
    {!done && !optional && <Circle size={16} className={`mt-0.5 shrink-0 ${pendingClass}`} />}

    <span className="min-w-0">
      {label}
      {optional && <span className="ml-1 whitespace-nowrap text-xs text-secondary-400">· optional</span>}
    </span>
  </li>
);

const Card = ({ icon: Icon, iconClass, badge, title, description, rows = [], footer = '', button, highlight = '', disabled = false }) => (
  <Link
    to={button.to}
    aria-disabled={disabled}
    className={`flex flex-col gap-3 rounded-2xl border p-5 transition-shadow ${highlight || 'border-gray-100'} ${disabled ? 'bg-gray-100 grayscale opacity-60 pointer-events-none' : 'bg-white hover:shadow-sm'}`}
  >
    <div className="flex items-start justify-between gap-3">
      <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl ${iconClass}`}>
        <Icon size={20} />
      </span>

      <StatusBadge status={badge.status} icon={badge.icon} className={`text-[10px] font-bold uppercase tracking-wider ${badge.className}`} />
    </div>

    <div>
      <p className="text-base font-bold text-secondary-900">{title}</p>
      <p className="mt-0.5 text-sm text-secondary-400">{description}</p>
    </div>

    <ul className="space-y-2">
      {rows.slice(0, MAX_ROWS).map((row) => <Row key={row.id} {...row} />)}

      {rows.length > MAX_ROWS && (
        <li className="pl-[26px] pt-1">
          <span className="inline-flex items-center gap-1 rounded-full border border-gray-200 bg-secondary-50 py-1 pl-2.5 pr-1.5 text-[11px] font-semibold text-secondary-600">
            +{rows.length - MAX_ROWS} more
            <ChevronRight size={12} strokeWidth={2.5} />
          </span>
        </li>
      )}
    </ul>

    <div className="mt-auto flex items-center justify-end gap-3 border-t border-gray-100 pt-4">
      {footer && <span className="mr-auto text-sm text-secondary-400">{footer}</span>}

      <span className={`btn h-10 min-h-0 gap-1.5 rounded-xl px-5 font-semibold ${CARD_BTN[button.primary ? 'primary' : 'outline']}`}>
        {button.label}
        {button.primary && <ArrowRight size={15} strokeWidth={2.5} />}
      </span>
    </div>
  </Link>
);

export default Card;
